import React from 'react'
import "./login.css"
import Navbar from '../../navbar/Navbar'
function Login() {
  return (
    <>
        <Navbar/>
        <h1>Log in page</h1>
    </>
  )
}

export default Login